import { render, staticRenderFns } from "./receiverSetting.vue?vue&type=template&id=43807daf&scoped=true"
import script from "./receiverSetting.vue?vue&type=script&lang=js"
export * from "./receiverSetting.vue?vue&type=script&lang=js"
import style0 from "./receiverSetting.vue?vue&type=style&index=0&id=43807daf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43807daf",
  null
  
)

export default component.exports